const Bicycle = (props) => (
  <svg
    fill="#ffffff"
    stroke="#ffffff"
    width="30px"
    height="30px"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M23,17a4,4,0,1,0-4,4A4,4,0,0,0,23,17Zm-4,2a2,2,0,1,1,2-2A2,2,0,0,1,19,19ZM5,21a4,4,0,1,0-4-4A4,4,0,0,0,5,21Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,5,15ZM15.707,6.293,18.414,9H20a1,1,0,0,1,0,2H18a1,1,0,0,1-.707-.293L15,8.414,11.414,12l1.293,1.293A1,1,0,0,1,13,14v4a1,1,0,0,1-2,0V14.414L9.293,12.707a1,1,0,0,1,0-1.414l5-5A1,1,0,0,1,15.707,6.293ZM18,6a2,2,0,1,1,2-2A2,2,0,0,1,18,6Z" />
  </svg>
);

export default Bicycle;
